import Chip from "@mui/material/Chip";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const PRIORITE_CONFIG = {
  1: {
    label: "Critique / Urgente",
    Icon: ReportProblemIcon,
    bgColor: "#C62828",
    textColor: "#ffffff",
  },
  2: {
    label: "Haute",
    Icon: KeyboardDoubleArrowUpIcon,
    bgColor: "#E65100",
    textColor: "#ffffff",
  },
  3: {
    label: "Moyenne",
    Icon: DragHandleIcon,
    bgColor: "#455A64",
    textColor: "#ffffff",
  },
  4: {
    label: "Basse",
    Icon: KeyboardArrowDownIcon,
    bgColor: "#757575",
    textColor: "#ffffff",
  },
};

export function labelFromPriorite(value) {
  const v = value != null && value !== "" ? Number(value) : null;
  if (!v || !PRIORITE_CONFIG[v]) return "";
  return PRIORITE_CONFIG[v].label;
}

export function getPrioriteConfig(value) {
  const v = value != null && value !== "" ? Number(value) : null;
  if (!v || !PRIORITE_CONFIG[v]) {
    return {
      label: "",
      Icon: null,
      bgColor: "#e0e0e0",
      textColor: "#313635",
    };
  }
  return PRIORITE_CONFIG[v];
}

export function PrioriteChip({ priorite, label, size = "small", prefix = "" }) {
  const config = getPrioriteConfig(priorite);
  const displayLabel = label || config.label;
  if (!displayLabel) return null;

  const { Icon, bgColor, textColor } = config;
  const chipLabel = prefix ? `${prefix}${displayLabel}` : displayLabel;

  return (
    <Chip
      size={size}
      label={chipLabel}
      icon={Icon ? <Icon /> : undefined}
      aria-label={`Priorité ${displayLabel}`}
      sx={{
        bgcolor: bgColor,
        color: textColor,
        fontWeight: 500,
        "& .MuiChip-icon": { color: textColor },
      }}
    />
  );
}
